import styled from "styled-components";
import { colors } from "../../../../styles/variables";

export const StyledReturnBy = styled.div`
  font-style: italic;
`;

export const StyledExchangeReturnByDate = styled.div`
  color: ${colors.gray600};
  display: flex;
  justify-content: flex-start;
  line-height: normal;
`;

export const StyledExchangeDetails = styled.div`
  color: ${colors.gray600};
  font-size: 13px;
  padding-top: 2px;
`;

export const StyledExchangeLogo = styled.div`
  margin-right: 4px;
`;
